<template>
    <div class="vx-col  w-full p-0" :class="wrapclass" >
        <div class="main-list">
           <p>
            {{label}}
            
            <span v-if="formater && formaterType">
                {{ $options.filters[formaterType](fieldValue) }}
            </span>
            <span v-else>{{fieldValue }}</span>
           </p> 
        </div>
    </div>
</template>

<script>
    export default{
        data: () => ({
            tempVisa:[]
        }),
        methods:{
        },
        mounted(){
          
        },
        props: {
            fieldValue:null,
            label:null,
            formater:{
                type:Boolean,
                default:true
            },
            formaterType:{
                type:String,
                default:'booleanFormat'
            },
            wrapclass:{
                type:String,
                default:'md:w-1/3'
            },
        }
    }
</script>
    